import React from 'react';
import PropTypes from 'prop-types';

import circleCheckPng from '../../../../../assets/icons/circle_check.png';

/**
 * The FeatureList Component
 */
class FeatureList extends React.Component {
  /**
   * Renders the FeatureList Component
   * @returns {{}}
   */
  render() {
    return (
      <div className="px-2">
        {this.props.features.map((feature) => {
          return (
            <div className="d-flex py-1" key={feature}>
              <img src={circleCheckPng} height={25} width={25} />
              <div className="item-feature-content">{feature}</div>
            </div>
          );
        })}
      </div>
    );
  }
}

FeatureList.propTypes = {
  features: PropTypes.arrayOf(PropTypes.string),
};

FeatureList.defaultProps = {
  features: [],
};

export default FeatureList;
